import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { _className, ComponentSync, LL_H_C, LL_V_L, Show, TS_Checkbox, TS_PropRenderer } from '@nu-art/thunderstorm-frontend/index';
import { VariableTypes } from '@app/hcs-shared';
import { ICONS } from '@app/styles';
import { groupArrayBy, MUSTNeverHappenException } from '@nu-art/ts-common';
import './Component_ContextRule.scss';
import { ModuleFE_Tag } from '../../_entity/tag/index.js';
import { Component_TagEditor } from '../../ui/index.js';
export class Component_ContextRule extends ComponentSync {
    //######################### Life Cycle #########################
    deriveStateFromProps(nextProps, state) {
        state.editable = nextProps.editable;
        state.editMode = !!nextProps.editMode;
        state.ruleIndex = nextProps.ruleIndex;
        state.focused = !!nextProps.focused;
        state.deleteInProgress ??= false;
        return state;
    }
    //######################### Logic #########################
    getUITagGroups = () => {
        const tagIds = this.state.editable.item.tagIds ?? [];
        const groups = groupArrayBy(tagIds, tagId => {
            const tag = ModuleFE_Tag.cache.unique(tagId);
            if (!tag)
                throw new MUSTNeverHappenException(`tag with id ${tagId} not found`);
            return tag.tagIds[0];
        });
        return groups.map(group => {
            const key = ModuleFE_Tag.cache.unique(group.key);
            if (!key)
                throw new MUSTNeverHappenException(`Could not find tag for id ${group.key}`);
            const value = group.values.map(id => {
                const tag = ModuleFE_Tag.cache.unique(id);
                if (!tag)
                    throw new MUSTNeverHappenException(`Could not find tag for id ${id}`);
                return tag;
            });
            return {
                key,
                value
            };
        });
    };
    deleteRule = () => {
        if (!this.props.onRuleDelete)
            return;
        this.setState({ deleteInProgress: true }, async () => {
            try {
                await this.props.onRuleDelete?.(this.state.ruleIndex);
            }
            catch (err) {
                this.logError(err);
            }
            finally {
                if (this.mounted)
                    this.setState({ deleteInProgress: false });
            }
        });
    };
    //######################### Render #########################
    render() {
        const className = _className('context-rule', this.state.focused && 'focused', this.state.deleteInProgress && 'disabled');
        return _jsxs(LL_V_L, { className: className, children: [this.renderHeader(), this.renderBody()] });
    }
    //######################### Render - Header #########################
    renderHeader = () => {
        const showFocus = !!this.props.onRuleFocus;
        const showDelete = this.state.editMode && !!this.props.onRuleDelete;
        return _jsx(LL_H_C, { className: 'context-rule__header', children: _jsxs(Show, { children: [_jsx(Show.If, { condition: showFocus, children: _jsx(TS_Checkbox, { checked: this.state.focused, onCheck: () => this.props.onRuleFocus?.(this.state.ruleIndex), icon: _jsx(ICONS.search.component, {}) }) }), _jsxs(Show.If, { condition: true, children: ["Rule ", this.state.ruleIndex + 1] }), _jsx(Show.If, { condition: showDelete, children: _jsx(ICONS.x.component, { onClick: this.deleteRule, className: 'context-rule__header__delete' }) })] }) });
    };
    renderBody = () => {
        const tagGroups = this.getUITagGroups();
        return _jsxs(LL_V_L, { className: 'context-rule__body', children: [_jsx(LL_H_C, { className: 'context-rule__variable-checks', children: this.renderVariableType() }), _jsx(Component_TagEditor, { tags: tagGroups, disableEdit: !this.state.editMode, groupTagFilter: () => true, hideDropdownDesign: true, singleTagFilter: (tag, groupTag) => {
                        return tag.tagIds[0] === groupTag._id;
                    }, onChange: async () => {
                        const tagIds = tagGroups.map(tagGroup => tagGroup.value.map(tag => tag._id)).flat();
                        await this.state.editable.update('tagIds', tagIds);
                    } })] });
    };
    renderVariableType = () => {
        const variableTypes = this.state.editable.editProp('variableTypes', []);
        return _jsx(TS_PropRenderer.Vertical, { label: 'Variable Types', children: _jsx(LL_H_C, { className: 'context-rule__check-list', children: VariableTypes.map(type => {
                    return _jsx(TS_Checkbox, { disabled: !this.state.editMode, icon: _jsx(ICONS.v.component, {}), checked: variableTypes.item?.includes(type), onCheck: checked => {
                            if (checked)
                                return variableTypes.updateArrayAt(type);
                            const index = variableTypes.item.indexOf(type);
                            return variableTypes.removeArrayItem(index);
                        }, children: type }, type);
                }) }) });
    };
}
//# sourceMappingURL=Component_ContextRule.js.map